import { ChangeDetectionStrategy, Component, TemplateRef, computed, input } from '@angular/core';
import { PageSectionContainer } from '@cfp/core';
import { TranslateModule } from '@ngx-translate/core';
import { PortfolioBuildingsRoadmapBuildingDTO, PortfolioBuildingsRoadmapDTO } from 'csr-asset-app';
import { ReportBuildingsLegend, ReportPortfolioRoadmapTable } from '../../components';
import { ReportPage } from '../report-page';

const MAX_BUILDINGS_ALL_PAGES = 20;

@Component({
  selector: 'cfp-report-investment-pages',
  templateUrl: 'report-investment-pages.html',
  imports: [ReportPage, ReportPortfolioRoadmapTable, ReportBuildingsLegend, PageSectionContainer, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportInvestmentPages {
  public readonly customerName = input.required<string>();
  public readonly buildingsWithPlan = input.required<PortfolioBuildingsRoadmapBuildingDTO[]>();
  public readonly portfolioBuildingsRoadmap = input.required<PortfolioBuildingsRoadmapDTO>();
  public readonly years = input.required<string[]>();
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');
  public readonly showLegend = input(true);
  public readonly headerLogo = input<string | undefined>(undefined);
  public readonly chromeFooter = input<TemplateRef<unknown> | undefined>(undefined);

  protected readonly pages = computed(() => {
    const data = this.buildingsWithPlan();
    if (!data) {
      return [];
    }

    const groups: PortfolioBuildingsRoadmapBuildingDTO[][] = [];
    let currentGroup: PortfolioBuildingsRoadmapBuildingDTO[] = [];

    data.forEach((item) => {
      if (currentGroup.length === MAX_BUILDINGS_ALL_PAGES) {
        groups.push(currentGroup);
        currentGroup = [];
      }
      currentGroup.push(item);
    });

    if (currentGroup.length > 0) {
      groups.push(currentGroup);
    }

    return groups;
  });

  protected translationKey(suffix: string): string {
    // Content keys always use the shared namespace (LBG overrides via custom i18n).
    // translationKeyPrefix is only for report-page chrome title (buildings vs RETLL).
    return `portfolioBuildingsRoadmapReport.${suffix}`;
  }
}
